<template>
  <svg width="29" height="38" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.3635 5.09094L2.18164 15.0303L8.79321 18.6416V28.581L20.3635 34.9091L31.9337 28.581V18.6416L35.2395 16.836V28.2829H38.5453V15.0303L20.3635 5.09094ZM31.6362 15.0303L20.3635 21.1927L9.09079 15.0303L20.3635 8.86786L31.6362 15.0303ZM20.3637 31.1321L28.6282 26.6097V20.4473L20.3637 24.9697L12.0993 20.4473V26.6097L20.3637 31.1321Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SchoolSvg'
}
</script>

<style scoped>
svg {
  fill: var(--color-green);
}
</style>
